/**
 * Opengater singleton-config hooks (users service). Each is one row: GET reads,
 * PUT updates. Same shape as usePricing — kept together since they're all thin.
 */
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiOg } from './client';
// ─── device-settings ───────────────────────────────────────────────────────
const DEVICE_PATH = '/api/v1/admin/device-settings';
export function useOgDeviceSettings() {
    return useQuery({
        queryKey: ['og', 'device-settings'],
        queryFn: () => apiOg('users', DEVICE_PATH),
    });
}
export function useUpdateOgDeviceSettings() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (patch) => apiOg('users', DEVICE_PATH, { method: 'PUT', body: patch }),
        onSuccess: (data) => qc.setQueryData(['og', 'device-settings'], data),
    });
}
// ─── topup-settings ────────────────────────────────────────────────────────
const TOPUP_PATH = '/api/v1/admin/topup-settings';
export function useOgTopup() {
    return useQuery({
        queryKey: ['og', 'topup-settings'],
        queryFn: () => apiOg('users', TOPUP_PATH),
    });
}
export function useUpdateOgTopup() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (patch) => apiOg('users', TOPUP_PATH, { method: 'PUT', body: patch }),
        onSuccess: (data) => qc.setQueryData(['og', 'topup-settings'], data),
    });
}
// ─── subscription-job ──────────────────────────────────────────────────────
const SUBJOB_PATH = '/api/v1/admin/subscription-job';
export function useOgSubscriptionJob() {
    return useQuery({
        queryKey: ['og', 'subscription-job'],
        queryFn: () => apiOg('users', SUBJOB_PATH),
    });
}
export function useUpdateOgSubscriptionJob() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (patch) => apiOg('users', SUBJOB_PATH, { method: 'PUT', body: patch }),
        onSuccess: (data) => qc.setQueryData(['og', 'subscription-job'], data),
    });
}
// ─── subscription-domain-settings ──────────────────────────────────────────
const SUBDOMAIN_PATH = '/api/v1/admin/subscription-domain-settings';
export function useOgSubscriptionDomain() {
    return useQuery({
        queryKey: ['og', 'subscription-domain'],
        queryFn: () => apiOg('users', SUBDOMAIN_PATH),
    });
}
export function useUpdateOgSubscriptionDomain() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (patch) => apiOg('users', SUBDOMAIN_PATH, { method: 'PUT', body: patch }),
        onSuccess: (data) => qc.setQueryData(['og', 'subscription-domain'], data),
    });
}
// ─── service-identity ──────────────────────────────────────────────────────
const IDENTITY_PATH = '/api/v1/admin/service-identity';
export function useOgServiceIdentity() {
    return useQuery({
        queryKey: ['og', 'service-identity'],
        queryFn: () => apiOg('users', IDENTITY_PATH),
    });
}
export function useUpdateOgServiceIdentity() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (patch) => apiOg('users', IDENTITY_PATH, { method: 'PUT', body: patch }),
        onSuccess: (data) => qc.setQueryData(['og', 'service-identity'], data),
    });
}
// ─── subscription-cutoff ───────────────────────────────────────────────────
const CUTOFF_PATH = '/api/v1/admin/subscription-cutoff';
export function useOgCutoff() {
    return useQuery({
        queryKey: ['og', 'subscription-cutoff'],
        queryFn: () => apiOg('users', CUTOFF_PATH),
    });
}
export function useUpdateOgCutoff() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (patch) => apiOg('users', CUTOFF_PATH, { method: 'PUT', body: patch }),
        onSuccess: (data) => qc.setQueryData(['og', 'subscription-cutoff'], data),
    });
}
// ─── referral-link-settings ────────────────────────────────────────────────
const REFERRAL_PATH = '/api/v1/admin/referral-link-settings';
export function useOgReferralLinks(enabled = true) {
    return useQuery({
        queryKey: ['og', 'referral-link-settings'],
        queryFn: () => apiOg('users', REFERRAL_PATH),
        enabled,
    });
}
export function useUpdateOgReferralLinks() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (patch) => apiOg('users', REFERRAL_PATH, { method: 'PUT', body: patch }),
        onSuccess: (data) => qc.setQueryData(['og', 'referral-link-settings'], data),
    });
}
